import React, { Component } from 'react';
import Breadcrumb from './ui/Breadcrumb.js'
import Store from './Store.js'

class ProtobufBreadcrumb extends Component {

    items(store, fullName) {
        var item = store.breadcrumbItem(fullName);
        if (item.parentFullName) {
            var parentItems = this.items(store, item.parentFullName);
            parentItems.push({name: item.name, link: item.fullName});
            return parentItems;
        } else {
            return [this.props.rootItem, {name: item.name, link: item.fullName}];
        }
    }

    render() {
        let store = new Store();
        var items = this.items(store, this.props.fullyQualifiedName);
        return (
            <Breadcrumb items={items} />
        )
    }
}

export default ProtobufBreadcrumb;



// WEBPACK FOOTER //
// ./src/reference/ProtobufBreadcrumb.js